
// import Header from "../Header/Header";
// import Footer from "../Header/Footer";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { useState } from "react";

// const Profile = () => {
//     const userName= localStorage.getItem('username')
//  const api = process.env.REACT_APP_API;
//     const apikey = process.env.REACT_APP_API_KEY;
// const [profileData, setProfileData] = useState(null);
// const [loading, setLoading] = useState(false);
// const [error, setError] = useState(null);
//   const navigate=useNavigate()



// const handleEdit = async () => {
//   setLoading(true);
//   setError(null);

//   try {
//     const response = await axios.get(
//       `${api}/api/getprofileeditdata/${userName}`,
//       {
//         headers: {
//           "x-api-key": apikey,
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     // Save data to state
//     const profileData = response.data.user[0];
//     setProfileData(profileData);
//     console.log("Profile data:", profileData);

//     const username = profileData.username;
//     const aadhaar = profileData.aadhaar_no;

//     // Navigate to edit profile page and pass data
//     navigate("/editprofile", {
//       state: {
//         profileData,
//         aadhaar,
//         username
//       },
//     });
//   } catch (err) {
//     console.error("Error fetching profile data:", err);
//     setError(err);
//   } finally {
//     setLoading(false);
//   }
// };


//   return (
//     <div>
//         <Header/>
//       <section>
//         <div className="db">
//           <div className="container">
//             <div className="row">
//               {/* Sidebar */}
//               <div className="col-md-4 col-lg-3">
//                 <div className="db-nav">
//                   <div className="db-nav-pro">
//                     <img
//                       src="images/profiles/12.jpg"
//                       className="img-fluid"
//                       alt=""
//                     />
//                   </div>
//                   <div className="db-nav-list">
//                  <ul>
//                       <li>
//                         <Link className="act" to={'/user/dashboard'}>
//                           <i
//                             className="fa fa-tachometer"
//                             aria-hidden="true"
//                           ></i>
//                           Dashboard
//                         </Link>
//                       </li>
//                       <li>
//                         <Link to={"/profile"}>
//                           <i className="fa fa-male" aria-hidden="true"></i>
//                           Profile
//                         </Link>
//                       </li>
//                       <li>
//                         <Link>
//                           <i
//                             className="fa fa-handshake-o"
//                             aria-hidden="true"
//                           ></i>
//                           Interests
//                         </Link>
//                       </li>
//                       <li>
//                         <Link>
//                           <i
//                             className="fa fa-commenting-o"
//                             aria-hidden="true"
//                           ></i>
//                           Chat list
//                         </Link>
//                       </li>
//                       <li>
//                         <Link>
//                           <i className="fa fa-money" aria-hidden="true"></i>Plan
//                         </Link>
//                       </li>
//                       <li>
//                         <Link>
//                           <i className="fa fa-cog" aria-hidden="true"></i>
//                           Setting
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                          to={"/login"}
//                           onClick={() => {
//                             localStorage.clear(); // remove all localStorage keys
//                             // navigate("/login"); // redirect after logout (optional)
//                           }}
//                         >
//                           <i className="fa fa-sign-out" aria-hidden="true"></i>{" "}
//                           Log out
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>

//               {/* Main Content */}
//               <div className="col-md-8 col-lg-9">
//                 <div className="row">
//                   {/* Profile Section */}
//                   <div className="col-md-12 col-lg-6 col-xl-8 db-sec-com">
//                     <h2 className="db-tit">Profiles status</h2>
//                     <div className="db-profile">
//                       <div className="img">
//                         <img
//                           src="images/profiles/12.jpg"
//                           loading="lazy"
//                           alt=""
//                         />
//                       </div>
//                       <div className="edit"><a
//                       // onClick={editprofilephoto}
//                           className="cta-dark"
//                           target="_blank"
//                         >
//                           Edit profile photo
//                         </a></div>
//                       <div className="edit">
//                         <a
//                         // to={'/editprofile'}
//                         onClick={handleEdit}
//                           className="cta-dark"
//                           target="_blank"
//                         >
//                           Edit profile
//                         </a>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Profile Stats */}
//                   <div className="col-md-12 col-lg-6 col-xl-4 db-sec-com">
//                     <h2 className="db-tit">Profiles status</h2>
//                     <div className="db-pro-stat">
//                       <h6>Profile completion</h6>
//                       <div className="dropdown">
//                         <button
//                           type="button"
//                           className="btn btn-outline-secondary"
//                           data-bs-toggle="dropdown"
//                         >
//                           <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
//                         </button>
//                         <ul className="dropdown-menu">
//                           <li>
//                             <a className="dropdown-item" href="#">
//                               Edit profile
//                             </a>
//                           </li>
//                           <li>
//                             <a className="dropdown-item" href="#">
//                               View profile
//                             </a>
//                           </li>
//                           <li>
//                             <a className="dropdown-item" href="#">
//                               Profile visibility settings
//                             </a>
//                           </li>
//                         </ul>
//                       </div>

//                       <div className="db-pro-pgog">
//                         <span>
//                           <b className="count">90</b>%
//                         </span>
//                       </div>

//                       <ul className="pro-stat-ic">
//                         <li>
//                           <span>
//                             <i className="fa fa-heart-o like" aria-hidden="true"></i>
//                             <b>12</b> Likes
//                           </span>
//                         </li>
//                         <li>
//                           <span>
//                             <i className="fa fa-eye view" aria-hidden="true"></i>
//                             <b>12</b> Views
//                           </span>
//                         </li>
//                         <li>
//                           <span>
//                             <i className="fa fa-handshake-o inte" aria-hidden="true"></i>
//                             <b>12</b> Interests
//                           </span>
//                         </li>
//                         <li>
//                           <span>
//                             <i className="fa fa-hand-pointer-o clic" aria-hidden="true"></i>
//                             <b>12</b> Clicks
//                           </span>
//                         </li>
//                       </ul>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Profile Views Chart */}
               
//               </div>
//               {/* End Main Content */}
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer/>
//     </div>
//   );
// };

// export default Profile;










import Header from "../Header/Header";
import Footer from "../Header/Footer";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useState, useRef, useEffect } from "react";

const Profile = () => {
  const userName = localStorage.getItem("username");
  const api = process.env.REACT_APP_API;
  const apikey = process.env.REACT_APP_API_KEY;

  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [presentage,setPresentage]=useState(0)
  const [profileImage, setProfileImage] = useState(null);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  // ----------------------------------------------------
  // FETCH Presentage 
  // ----------------------------------------------------
  
   const getPresentage = async () => {
  const username = localStorage.getItem("username");

  try {
    const res = await axios.get(
      `https://matrimony.bugchat.in/api/getPresentage/${username}`,
      {
        headers: { "x-api-key": apikey },
      }
    );
  setPresentage(res.data.presentage)
    
    // console.log("presentage", res.data.presentage);
    // return res.data.presentage; // if you want to use it later
  } catch (err) {
    console.error("Error fetching presentage:", err);
  }
};


  // ----------------------------------------------------
  // FETCH PROFILE PHOTO FROM DB
  // ----------------------------------------------------
  const getProfilePhoto = async () => {
    try {
      const res = await axios.get(
        `${api}/api/viewProfilePhoto/${userName}`,
        {
          headers: { "x-api-key": apikey }
        }
      );

      if (res.data?.user_photo) {
        setProfileImage(res.data.user_photo); // only filename
      }

    } catch (err) {
      console.log("Error loading profile photo:", err);
    }
  };

  useEffect(() => {
    getProfilePhoto();

    getPresentage()
  }, []);

  // ----------------------------------------------------
  // PICK PROFILE PHOTO
  // ----------------------------------------------------
  const handleEditProfilePhoto = () => {
    fileInputRef.current.click();
  };

  const handlePhotoChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // preview
    const previewUrl = URL.createObjectURL(file);
    setProfileImage(previewUrl);

    const formData = new FormData();
    formData.append("photo", file);
    formData.append("userName", userName);

    try {
      await axios.post(`${api}/api/uploadphoto`, formData, {
        headers: { "x-api-key": apikey }
      });

      // re-fetch server image (actual filename)
      getProfilePhoto();

    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  // ----------------------------------------------------
  // EDIT PROFILE REDIRECT
  // ----------------------------------------------------
  const handleEdit = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `${api}/api/getprofileeditdata/${userName}`,
        {
          headers: {
            "x-api-key": apikey,
            "Content-Type": "application/json",
          },
        }
      );

      const profileData = response.data.user[0];
      setProfileData(profileData);

      navigate("/editprofile", {
        state: {
          profileData,
          aadhaar: profileData.aadhaar_no,
          username: profileData.username,
        },
      });

    } catch (err) {
      console.error("Error:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  // ----------------------------------------------------
  // FORMAT FINAL IMAGE URL
  // ----------------------------------------------------
  const imageURL = profileImage?.startsWith("blob:")
    ? profileImage // preview
    : profileImage
    ? `${api}/upload/photo/${profileImage}` // DB photo
    : process.env.PUBLIC_URL + "/images/user/user.png"; // default

  return (
    <div>
      <Header />

      <section>
        <div className="db">
          <div className="container">
            <div className="row">

              {/* Sidebar */}
              <div className="col-md-4 col-lg-3">
                <div className="db-nav">
                  <div className="db-nav-pro">
                    <img src={imageURL} className="img-fluid" alt="" />
                  </div>

                  <div className="db-nav-list">
                    <ul>
                      <li><Link className="act" to={"/user/dashboard"}><i className="fa fa-tachometer"></i> Dashboard</Link></li>
                      <li><Link to={"/profile"}><i className="fa fa-male"></i> Profile</Link></li>
                      <li><Link><i className="fa fa-handshake-o"></i> Interests</Link></li>
                      <li><Link><i className="fa fa-commenting-o"></i> Chat list</Link></li>
                      <li><Link><i className="fa fa-money"></i> Plan</Link></li>
                      <li><Link><i className="fa fa-cog"></i> Setting</Link></li>

                      <li>
                        <Link
                          to={"/login"}
                          onClick={() => localStorage.clear()}
                        >
                          <i className="fa fa-sign-out"></i> Log out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Main Content */}
              <div className="col-md-8 col-lg-9">
                <div className="row">

                  {/* Left Section */}
                  <div className="col-md-12 col-lg-6 col-xl-8 db-sec-com">
                    <h2 className="db-tit">Profile Status</h2>

                    <div className="db-profile">
                      <div className="img">
                        <img src={imageURL} loading="lazy" alt="" />
                      </div>

                      <div className="edit">
                        <a className="cta-dark" onClick={handleEditProfilePhoto} style={{ cursor: "pointer" }}>
                          Edit profile photo
                        </a>

                        <input
                          type="file"
                          accept="image/*"
                          ref={fileInputRef}
                          onChange={handlePhotoChange}
                          style={{ display: "none" }}
                        />
                      </div>

                      <div className="edit">
                        <a className="cta-dark" onClick={handleEdit}>
                          Edit profile
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Right Section */}
                  <div className="col-md-12 col-lg-6 col-xl-4 db-sec-com">
                    <h2 className="db-tit">Profile Stats</h2>

                    <div className="db-pro-stat">
                      <h6>Profile completion</h6>

                      <div className="dropdown">
                        <button className="btn btn-outline-secondary" type="button" data-bs-toggle="dropdown">
                          <i className="fa fa-ellipsis-h"></i>
                        </button>

                        <ul className="dropdown-menu">
                          <li><a className="dropdown-item">Edit profile</a></li>
                          <li><a className="dropdown-item">View profile</a></li>
                          <li><a className="dropdown-item">Profile visibility settings</a></li>
                        </ul>
                      </div>

                      <div className="db-pro-pgog">
                        <span><b className="count">{presentage}</b>%</span>
                      </div>

                      <ul className="pro-stat-ic">
                        <li><span><i className="fa fa-heart-o like"></i> <b>12</b> Likes</span></li>
                        <li><span><i className="fa fa-eye view"></i> <b>12</b> Views</span></li>
                        <li><span><i className="fa fa-handshake-o inte"></i> <b>12</b> Interests</span></li>
                        <li><span><i className="fa fa-hand-pointer-o clic"></i> <b>12</b> Clicks</span></li>
                      </ul>

                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Profile;
